export default {
    mobile: 320,
    tablet: 768,
    desktop: 1200,

    query: {
        mobile: 'screen and (max-width: 767px)',
        tablet: 'screen and (min-width: 768px) and (max-width: 1199px)',
        desktop: 'screen and (min-width: 1200px)',
    }
};